import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-study-landing',
  templateUrl: './study-landing.component.html',
  styleUrls: ['./study-landing.component.css']
})
export class StudyLandingComponent implements OnInit {

  // https://codepen.io/justaashir/pen/mdeeKbz
  
  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }
  
  goToWebapp(){
    window.open('https://app.voyjaleas.com/#/sub-app/health-helper');
  }

}
